import { useDispatch, useSelector } from 'react-redux';

import { trackOpenContactPartnerModal } from 'src/components/molecules/ContactPartnerModal/tracking/contactPartnerModalEvents';
import { selectAccessibility } from 'src/redux/accessibility/selectors';
import type { ReduxApplicationState } from 'src/redux/combinedReducer';
import { actions } from 'src/redux/contactPartner/slice';
import { selectProduct } from 'src/redux/product/selectors';
import { getOptionsCostRange } from 'src/redux/product/utils/getOptionsCostRange';
import { selectProductReviews } from 'src/redux/reviews/selectors';
import { isSuspended } from 'src/utils/inventoryStatus';

export const useStandardLayout = () => {
  const dispatch = useDispatch();
  const state = useSelector((state: ReduxApplicationState) => state);
  const accessibility = selectAccessibility(state);
  const product = selectProduct(state);
  const reviews = selectProductReviews(state);
  const suspended = isSuspended(product.availability, product.available);
  const partnerName = product.partner.name;

  const openContactPartnerModal = () => {
    dispatch(actions.openContactPartnerModal());
    trackOpenContactPartnerModal(partnerName);
  };

  return {
    deliveryOptionsLoaded: Boolean(state.delivery.zones),
    offerLabel: state.content.offerLabel || null,
    openContactPartnerModal,
    optionsCostRange: getOptionsCostRange(product.options, product.price.currency),
    pageLiveRegionText: accessibility.statusMessage,
    partnerHref: `/partners/${product.partner.shortcode}`,
    product,
    reviews,
    suspended,
  };
};
